import request from '@/utils/request'

export function getCoupons (params) {
  return request({
    url: '/b2c/coupons',
    method: 'get',
    params
  })
}

export function getWeekCoupons (params) {
  return request({
    url: '/b2c/week/coupons',
    method: 'get',
    params
  })
}

export function getCouponDetail (couponId) {
  return request({
    url: '/b2c/coupon/' + couponId,
    method: 'get'
  })
}

export function receiveCoupon (params) {
  return request({
    url: '/b2c/coupon/download',
    method: 'post',
    data: params
  })
}

export function getCouponBanners (params) {
  return request({
    url: '/b2c/coupon/banners',
    method: 'get',
    params
  })
}

export function getCode (params) {
  return request({
    url: '/member/verification/code',
    method: 'get',
    params
  })
}


export function login (params) {
  return request({
    url: '/member/login',
    method: 'get',
    params
  })
}

export function getInfo () {
  return request({
    url: '/member/info',
    method: 'get'
  })
}

export function getMemberCoupons (params) {
  return request({
    url: '/member/coupons',
    method: 'get',
    params
  })
}

export function getMemberCampaigns (params) {
  return request({
    url: '/member/campaigns',
    method: 'get',
    params
  })
}

// 通过 memberId 获取会员卡页面url
export function getMemberUrl (memberId, params) {
  return request({
    url: `/member/campaign/card_url/${memberId}`,
    method: 'get',
    params
  })
}

export function getSystemConfig (key) {
  return request({
    url: '/b2c/system_config/' + key,
    method: 'get'
  })
}

export function createOrder (params) {
  return request({
    url: '/member/order',
    method: 'post',
    data: params
  })
}

export function payOrder (orderId, returnUrl) {
  return request({
    url: `/member/order/${orderId}/pay?returnUrl=${returnUrl}`,
    method: 'get',
  })
}
